module.exports = __webpack_public_path__ + "assets/media/s18.d5a12ee2.mp3";